// @flow
import React from 'react';

function NotificationsBox() {
  return <div>Notifications</div>;
}

export { NotificationsBox };
